import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { RecommendedQuestion } from '../../../../services/recommendedQuestion';
import ConfirmModal from '../../../../components/common/ConfirmModal';

interface DisabledQuestionItemProps {
  question: RecommendedQuestion;
  canEnable: boolean;
  onEnable: (id: string) => void;
  onDelete: (id: string) => void;
}

export default function DisabledQuestionItem({
  question,
  canEnable,
  onEnable,
  onDelete,
}: DisabledQuestionItemProps) {
  const { t } = useTranslation();
  const [confirmDelete, setConfirmDelete] = useState(false);

  return (
    <>
      <div className="flex items-center gap-4 px-5 py-3.5 border-b border-gray-100 last:border-b-0 hover:bg-gray-50/40 transition-colors group">
        {/* 问题内容 */}
        <span className="flex-1 text-sm text-gray-600 leading-relaxed">{question.Question}</span>

        {/* 操作按钮 */}
        <div className="flex items-center gap-1.5 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
          {canEnable ? (
            <button
              type="button"
              onClick={() => onEnable(question.ID)}
              className="px-2.5 py-1.5 rounded-md text-xs font-medium cursor-pointer whitespace-nowrap transition-colors"
              style={{ backgroundColor: '#F0EAF5', color: '#830051' }}
            >
              {t('rec.enable')}
            </button>
          ) : (
            <span
              className="px-2.5 py-1.5 rounded-md text-xs font-medium whitespace-nowrap cursor-not-allowed"
              style={{ backgroundColor: '#F4F4F4', color: '#BBB' }}
              title={t('rec.maxEnabledHint')}
            >
              {t('rec.enable')}
            </span>
          )}
          <Link
            to={`/admin/recommended-questions/${question.ID}`}
            className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 cursor-pointer transition-colors"
            title={t('common.edit')}
          >
            <i className="ri-edit-2-line text-sm"></i>
          </Link>
          <button
            type="button"
            onClick={() => setConfirmDelete(true)}
            className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 cursor-pointer transition-colors"
            title={t('common.delete')}
          >
            <i className="ri-delete-bin-line text-sm"></i>
          </button>
        </div>
      </div>

      {/* 删除确认弹窗 */}
      <ConfirmModal
        open={confirmDelete}
        title={t('rec.deleteConfirm')}
        description={question.Question}
        confirmText={t('common.delete')}
        confirmColor="danger"
        onConfirm={() => { onDelete(question.ID); setConfirmDelete(false); }}
        onCancel={() => setConfirmDelete(false)}
      />
    </>
  );
}
